import { Injectable } from '@angular/core';
import { NotificationClient, NotificationDto, NotificationStatus, UpdateNotificationStatusByCommentIdCommand } from '../web-api-client';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private notificationClient: NotificationClient,) { }

  async GetNotificationByCommentId(id){
    return await this.notificationClient.notificationsByCommentId(id).toPromise();
  }
  async ChangeNotificationStatus(commentId:string,status : NotificationStatus ){
    var command = new UpdateNotificationStatusByCommentIdCommand();
    command.commentId = commentId;
    command.status = status
    return await this.notificationClient.updateNotificationStatusByCommentId(command).toPromise()
  }

}
